import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { DASHBOARD_ICONS } from "../../../Helpers/ICONS";
import { TRADER_ROUTES } from "../../../app/router/routes";
import NavBar from "../../../components/navbar/NavBar";
import { SectionColumn } from "../../../layouts/sections";

import { getStepStatusByApplicationId } from "../../../app/api/NOCU/applicationAPI";
import { getStakeholderApplicationNumber } from "../../../app/api/NOCU/helpers/applicationApiHelpers";
import LoaderComponent from "../../../components/Loader/LoaderComponent";
import { createStepper } from "../../../components/stepper/dynamicStepper";
import { convertStepperRes } from "./dataManipulation";
import TraderStep1 from "./flow/TraderStep1";
import TraderStep2 from "./flow/TraderStep2";
import TraderStep3 from "./flow/TraderStep3";
import TraderStep4 from "./flow/TraderStep4";
import TraderStep5 from "./flow/TraderStep5";
import TraderStep6 from "./flow/TraderStep6";
import { getApplicationStatusOnSession } from "../../certificationBody/dataManipulation";

export const stepperName = "TRADER";

const TraderReviewHome = () => {
	const [res, setRes] = useState();
	const [stepper, setStepper] = useState();
	const [stepperData, setStepperData] = useState();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		getStepStatusByApplicationId(getStakeholderApplicationNumber())
			.then((res) => {
				setRes(res.data);
				console.log("Data", res.data);
				console.log("Stepper=====>", convertStepperRes(res.data));
				setStepper(convertStepperRes(res.data));
			})
			.catch((e) => console.log(e));
	}, []);

	useEffect(() => {
		stepper && setStepperData(createStepper(stepperName, stepper));
	}, [stepper]);

	const routeArray = [
		TRADER_ROUTES.STEP01,
		TRADER_ROUTES.STEP02,
		TRADER_ROUTES.STEP03,
		TRADER_ROUTES.STEP04,
		TRADER_ROUTES.STEP05,
		TRADER_ROUTES.STEP06,
	];
	return (
		<div>
			<LoaderComponent isOpen={isLoading} />
			<NavBar
				stepperName={stepperName}
				title={"Trader"}
				tableIcon={DASHBOARD_ICONS.trader}
				tableURL={TRADER_ROUTES.HOME}
			/>

			{res && stepperData && (
				<SectionColumn className='w-full pt-1'>
					<Route path={TRADER_ROUTES.STEP01}>
						<TraderStep1
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[0]?.reviewStatus === "APPROVED" || res[0]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
					<Route path={TRADER_ROUTES.STEP02}>
						<TraderStep2
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[1]?.reviewStatus === "APPROVED" || res[1]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
					<Route path={TRADER_ROUTES.STEP03}>
						<TraderStep3
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[2]?.reviewStatus === "APPROVED" || res[2]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>

					<Route path={TRADER_ROUTES.STEP04}>
						<TraderStep4
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[9]?.reviewStatus === "APPROVED" || res[9]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
					<Route path={TRADER_ROUTES.STEP05}>
						<TraderStep5
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[3]?.reviewStatus === "APPROVED" || res[3]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
					<Route path={TRADER_ROUTES.STEP06}>
						<TraderStep6
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							readOnly={
								getApplicationStatusOnSession()
									? false
									: res[4]?.reviewStatus === "APPROVED" || res[4]?.reviewStatus === "RESUBMIT"
									? true
									: false
							}
						/>
					</Route>
				</SectionColumn>
			)}
		</div>
	);
};

export default TraderReviewHome;
